import React from "react"
import { TranslationKeys } from "../../../../contexts/TranslationKeys"
import { formatDate, getDaysOfTheWeek, getMonthsOfTheYear, getRecurrenceOptionss } from "../../../../utilities/DateUtils"
import { DAILY_OPTION, MONTHLY_OPTION, PATTERN, RECURRENCE, YEARLY_OPTION } from "../../../../constants/notification-key"

export const buildRecurrenceRangeSummary = (values, translate) => {
    return (
        <div className="flex-column mt-3">
        <h1 className="text-sm text-black font-bold">
            {translate.byKey(TranslationKeys.recurrenceRange)}:
        </h1>

        {values.recurrenceOption === RECURRENCE.END_BY && values.endDate
        ?
            <div className="text-sm text-black">
                {translate.byKeyFormatted(TranslationKeys.startAndEndBy, [formatDate(values.startDate), formatDate(values.endDate)])}
            </div>
        : 
            values.recurrenceOption === RECURRENCE.END_AFTER
            ?
                <div className="text-sm text-black">
                    {translate.byKeyFormatted(TranslationKeys.startAndEndAfter, [formatDate(values.startDate), values.rangeOccurrence])}
                </div>
            : 
                values.recurrenceOption=== RECURRENCE.NO_END_DATE
                ?
                    <div className="text-sm text-black">
                        {translate.byKey(TranslationKeys.start)} {formatDate(values.startDate)}
                    </div>
                :   
                    <div className="text-sm text-black">
                        {translate.byKey(TranslationKeys.start)} {formatDate(values.startDate)}
                    </div>
        }
    </div>
    )
}

export const buildRecurrencePatternSummary = (values, translate) => {
    return <>
        <div className="flex-column mt-3">
            <h1 className="text-sm text-black font-bold">
                {translate.byKey(TranslationKeys.recurrencePattern)}:
            </h1>
        </div>
        {values.pattern === PATTERN.DAILY
            ? buildDailyRecurrencePatternSummary(values, translate)
            : values.pattern === PATTERN.WEEKLY
                ? buildWeeklyRecurrencePatternSummary(values, translate)
                :  values.pattern === PATTERN.MONTHLY
                    ? buildMonthlyRecurrencePatternSummary(values, translate)
                    :  values.pattern === PATTERN.YEARLY
                        ? buildYearlyRecurrencePatternSummary(values, translate)
                        : <></>
        } 
    </>
}

const buildDailyRecurrencePatternSummary = (values , translate) => {
    return (
        <div className="text-sm text-black">
            {values.dailyOption === DAILY_OPTION.EVERY 
                ?
                translate.byKeyFormatted(TranslationKeys.dailyRecurEveryDay, [values.occurrences])
                : 
                translate.byKey(TranslationKeys.recurEveryWeekday)
            }
        </div>
    )
}

const buildWeeklyRecurrencePatternSummary = (values, translate) => {
    const allDaysOfWeek = getDaysOfTheWeek(translate)
   
    const labels = values.daysOfTheWeek.map(day => {
        const correspondingDay = allDaysOfWeek.find(option => option.value === day);
        return correspondingDay ? correspondingDay.label : null;
    });
    
    return (<>
            <div className="text-sm text-black">
                {
                   translate.byKeyFormatted(TranslationKeys.recurEveryWeekWeeks, [values.occurrences])
                }
            </div>

            <div className="flex-column mt-3">
                <h1 className="text-sm text-black font-bold">
                    {translate.byKey(TranslationKeys.dayDays)}
                </h1>
                {labels.map((day, index) => {
                    return (
                        <span className="text-sm text-black mr-1" key={index}>
                            {day}{" "}
                        </span>
                    );
                })}
            </div>
            </>   
    )
}

const buildMonthlyRecurrencePatternSummary = (values, translate) => {
    const allDaysOfWeek = getDaysOfTheWeek(translate)
    const day = allDaysOfWeek.find((day) => values.daysOfTheWeek === day.value)?.label

    const allRecurrenceOptions = getRecurrenceOptionss(translate)
    const recurrenceOption = allRecurrenceOptions.find((option) => values.occurrence === option.value)?.label

    return (<>
            <div className="text-sm text-black">
                {values.monthlyOption === MONTHLY_OPTION.DAY
                ?
                    translate.byKeyFormatted(TranslationKeys.recurEveryMonthMonths, [values.dayOfMonth, values.occurrences])
                :
                    translate.byKeyFormatted(TranslationKeys.recurSpecificMonth, [recurrenceOption, day, values.occurrences])
                }
            </div>
            </>   
    )
}

const buildYearlyRecurrencePatternSummary = (values, translate) => {
    const selectedMonth = getMonthsOfTheYear(translate).find(option => option.value === values.monthOfTheYear);
    const chosenMonth: string = selectedMonth?.label ?? '';
    const allDaysOfWeek = getDaysOfTheWeek(translate)
    const day = allDaysOfWeek.find((day) => values.daysOfTheWeek === day.value)?.label

    const allRecurrenceOptions = getRecurrenceOptionss(translate)
    const recurrenceOption = allRecurrenceOptions.find((option) => values.occurrence === option.value)?.label

    return (<>
            <div className="text-sm text-black mr-1">
                {values.yearlyOption === YEARLY_OPTION.ON
                ?
                translate.byKeyFormatted(TranslationKeys.recurEveryYear, [values.occurrences, chosenMonth, values.dayOfMonth])
                :
                translate.byKeyFormatted(TranslationKeys.recurEveryYearWithMonthAndDay, [values.occurrences, recurrenceOption, day, chosenMonth])
                }
            </div>
            </>   
    )
}